import { Circle, GoogleMap, Marker } from '@react-google-maps/api'
import { GoogleMapsLoader } from 'components/GoogleMapsLoader'
import mapTheme from 'data/map-theme.json'
import { ComponentType } from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding-top: 24px;
  padding-bottom: 24px;

  ${up('sm')} {
    padding-top: 24px;
    padding-botton: 24px;
  }
`

const Title = styled.h4`
  font-size: 17px;
  font-weight: bold;
  line-height: 22px;
  margin-bottom: 10;
`

const Subtitle = styled.h6`
  color: #0078c9;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  margin-bottom: 24px;

  ${up('sm')} {
    margin-bottom: 24px;
  }
`

interface Props {
  property: any
}

export const Map: ComponentType<Props> = ({ property }) => {
  const lngLat = {
    lng: property.location.coordinates[0],
    lat: property.location.coordinates[1],
  }

  if (!!lngLat.lat && !!lngLat.lng) {
    return (
      <Wrapper className="googlemap-wrapper">
        <Title>Ubicación</Title>
        <Subtitle>{property.zone.name}</Subtitle>
        <GoogleMapsLoader>
          <GoogleMap
            zoom={15}
            mapContainerStyle={{
              border: '1px solid #C5CCD5',
              borderRadius: 10,
              height: 400,
            }}
            center={lngLat}
            options={{
              mapTypeControl: false,
              streetViewControl: false,
              styles: mapTheme as any,
            }}
          >
            {property.pin === true ? (
              <Marker position={lngLat} icon="/images/pin.svg" />
            ) : (
              <Circle
                radius={700}
                center={lngLat}
                options={{
                  strokeColor: '#0078C9',
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: 'rgba(0,120,201)',
                  fillOpacity: 0.25,
                  clickable: false,
                }}
              />
            )}
          </GoogleMap>
        </GoogleMapsLoader>
      </Wrapper>
    )
  }

  return null
}
